import { ExportTypes } from "../shared/enum/shared.enum";


export class ShowFile {

  windows(data: any, exportType?: ExportTypes, nameFile?: string) {
    // Verifica se o navegador oferece suporte a Blog object.
    // https://developer.mozilla.org/pt-BR/docs/Web/API/Blob    
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(data, nameFile);
    }
    else {
      const fileURL = URL.createObjectURL(data);
      if (exportType !== ExportTypes.Excel_xls && exportType !== ExportTypes.Excel_xlsx) {
        window.open(fileURL, '_blank');
      } else {
        if (exportType === ExportTypes.Excel_xlsx) {
          nameFile += '.xlsx';
        }
        const anchor: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        anchor.download = nameFile;
        anchor.href = fileURL;
        document.body.appendChild(anchor);
        anchor.click();
      }
    }
  }

  download(data: any, exportType?: ExportTypes, nameFile?: string) {
    // Verifica se o navegador oferece suporte a Blog object.
    // https://developer.mozilla.org/pt-BR/docs/Web/API/Blob
    const nav = (window.navigator as any);
    if (nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(data, nameFile);
    } else {
      const fileURL = URL.createObjectURL(data);
      const anchor: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      anchor.download = nameFile;
      anchor.href = fileURL;
      document.body.appendChild(anchor);
      anchor.click();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/show-file.ts